<template>
  <div class="pop">
    <div class="bg-in">
      <img
        src="../../assets/images/cashWheel/cashWheelPop.webp"
        style="max-width: 90vw; height: auto; border-radius: 10px"
        @click="goCashWheel"
      >
      <div class="cancel-btn" v-show="delayedAWhile" @click="close()">
        <img :src="cancelWhite" alt="cancel">
      </div>
    </div>
  </div>
</template>

<script>
import cancelWhite from '@/assets/images/common/cancelWhite.svg'
import {closePop} from '@/utils'
import store from '@/store/store'
import {setCurrentModal} from '../../utils'
export default {
  name: 'cashWheelPop',
  props: ['handleClose'],
  data () {
    return {
      cancelWhite,
      delayedAWhile: true,
      userInfo: JSON.parse(localStorage.getItem('userInfo'))
    }
  },
  watch: {
    '$store.state.locale': function () {}
  },
  components: {

  },
  mounted () {},
  methods: {
    goCashWheel () {
      closePop(15)
      this.$router.push('/cashWheel')
    },
    close () {
      closePop(15)
      if (store.state.callbackTimeSpan > (new Date()).getTime()) {
        store.commit('setCurrentModalIndex', 2) // 允许弹出回归礼包
        setCurrentModal(2)
      } else if (store.state.modals[3].popupTimes < store.state.modals[3].maxPopupTimes) {
        store.commit('setCurrentModalIndex', 3) // 允许弹出常态化流水活动
        setCurrentModal(3)
      } else if (store.state.modals[5].popupTimes < store.state.modals[5].maxPopupTimes && store.state.shareFiestaShow) {
        store.commit('setCurrentModalIndex', 5) // 弹出推广狂欢
        setCurrentModal(5)
      } else if (store.state.modals[11].popupTimes < store.state.modals[11].maxPopupTimes && new Date() < new Date('2024-08-19T00:00:00') && !localStorage.getItem('pop11ban')) {
        store.commit('setCurrentModalIndex', 11) // 站内信
        setCurrentModal(11)
      } else if (store.state.modals[13].popupTimes < store.state.modals[13].maxPopupTimes) {
        store.commit('setCurrentModalIndex', 13)
        setCurrentModal(13)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.pop {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0,0,0,.6);
  z-index: 9;
  padding: 40px 20px;
  box-sizing: border-box;
  overflow: auto;

  .bg-in {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50.05%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 96vw;

    .cancel-btn {
      width: 28px;
      height: 28px;
      margin-top: 14px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CashWheelPop/index.vue